import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

export class Navigation extends Component {

    changeColor(i, a, b) {
        document.getElementById(a).style.color = "";
        //document.getElementById(b).style.color = "";
        document.getElementById(i).style.color = "#fdd835";
    }

    render() {
        return (
            <div id="Navigation">
                <div className="navigation-bar Nav-Size black"></div>
                <div className="navigation-bar Nav-Size">
                    <div className="navigation-bar-logo-container">
                        <h1 className="navigation-bar-logo">FAB</h1>
                    </div>

                    <div className="navigation-bar-links-container">
                        {/*<Link to="/" id="Home" className="navigation-bar-link" onClick={() => this.changeColor("Home", "Color_Tool", "Usage")}>Home</Link>*/}
                        <Link to="/" id="Color_Tool" className="navigation-bar-link" onClick={() => this.changeColor("Color_Tool", "Usage")}>Color Tool</Link>
                        <Link to="/usage" id="Usage" className="navigation-bar-link" onClick={() => this.changeColor("Usage", "Color_Tool")}>Usage</Link>
                    </div>
                </div>
                <div className="Top-Spacer Nav-Size">{/*   Creats a Spacing when you reach the top, so the content below hide behind the bar  */}</div>
            </div>





        )
    }
}